<template>
  <div>
    <Dialog
      :header="`Manage ${items.length} ${mtype == 1 ? 'Games' : 'Timeslots'}`"
      :visible.sync="open"
      :closable="true"
      @hide="hideModal"
      :style="{ width: '1200px', maxWidth: '90%' }"
      :modal="true"
    >
      <div class="p-grid p-p-3 p-pt-0" style="height: 100%;">
        <div class="p-col-12" v-show="mtype != 1">
          <div class="title is-4">{{ $t("ManageTimeslotsModal.choose_action") }}</div>
        </div>
        <div class="p-col" v-show="mtype != 1">
          <Button
            class="timeslotActionButton p-button-secondary"
            v-bind:class="{ 'p-button-outlined': action != 'copy' }"
            @click="action = 'copy'"
            >{{ $t("copy-until") }}
          </Button>
        </div>
        <div class="p-col" v-show="mtype != 1">
          <Button
            class="timeslotActionButton p-button-secondary"
            v-bind:class="{ 'p-button-outlined': action != 'shift' }"
            @click="action = 'shift'"
            >{{ $t("shift-times") }}
          </Button>
        </div>
        <div class="p-col" v-show="mtype != 1">
          <Button
            class="timeslotActionButton p-button-secondary"
            v-bind:class="{ 'p-button-outlined': action != 'update' }"
            @click="action = 'update'"
            >{{ $t("assign-attributes") }}
          </Button>
        </div>
        <div class="p-col" v-show="mtype != 1">
          <Button
            class="timeslotActionButton p-button-secondary"
            v-bind:class="{ 'p-button-outlined': action != 'surface' }"
            @click="action = 'surface'"
            >{{ $t("assign-surfaces") }}
          </Button>
        </div>
        <div class="p-col" v-show="mtype != 1">
          <Button
            class="timeslotActionButton p-button-secondary"
            v-bind:class="{ 'p-button-outlined': action != 'split' }"
            @click="action = 'split'"
            >{{ $t("split-timeslots") }}
          </Button>
        </div>
        <div class="p-col" v-show="mtype != 1">
          <Button
            class="timeslotActionButton p-button-secondary"
            v-bind:class="{ 'p-button-outlined': action != 'delete' }"
            @click="action = 'delete'"
            >{{ $t("delete-timeslots") }}
          </Button>
        </div>
        <div class="p-col-12 p-my-2"></div>
        <div v-if="action == 'copy'" class="p-col-12" style="padding-bottom: 200px">
          <div class="p-grid">
            <div class="p-col-6">
              <div class="title is-5">{{ $t("copy-from") }}</div>
              {{ firstDate }}
              <br /><br />
              <div class="title is-5">{{ $t("copy-frequency") }}</div>
              <Dropdown
                :options="frequencies"
                :placeholder="$t('choose-frequency')"
                style="width: 100%"
                class="p-mt-1"
                v-model="copyFrequency"
              />
            </div>
            <div class="p-col-6">
              <div class="title is-5">{{ $t("copy-until") }}</div>
              <div v-if="sconfig">
                {{ sconfig.realEnd }}
                <br /><br />
              </div>
              <div id="datePicker" class="p-text-center"></div>
              <AirbnbStyleDatepicker
                :monthsToShow="1"
                triggerElementId="datePicker"
                :mode="'single'"
                :date-one="copyDate"
                v-model="copyDate"
                :minDate="firstDate"
                :inline="true"
                @date-one-selected="setCopyDate"
                :startOpen="true"
                style="margin: 0 auto"
                :close-after-select="true"
              />
            </div>
            <div class="p-col-12 p-mt-2">
              <Button :disabled="!copyDate" class="p-button p-button-lg" :label="$t('copy-timeslots')" @click="copy" />
            </div>
          </div>
        </div>
        <div v-else-if="action == 'shift'" class="p-col-12" style="padding-bottom: 200px">
          <div class="title is-5">{{ $t("shift-by") }}</div>
          <div class="p-grid">
            <div class="p-col-6">
              <Dropdown
                :options="moveOptions.numbers"
                :placeholder="$t('choose-amount')"
                style="width: 100%"
                class="p-mt-3"
                v-model="moveChoices.amount"
              />
            </div>
            <div class="p-col-6">
              <Dropdown
                :options="moveOptions.units"
                :placeholder="$t('choose-unit')"
                style="width: 100%"
                class="p-mt-3"
                v-model="moveChoices.units"
              />
            </div>
            <div class="p-col-12 p-mt-2">
              <Button
                class="p-button p-button-lg"
                :label="mtype == 1 ? $t('shift-game') : $t('shift-timeslots')"
                @click="shift"
              />
            </div>
          </div>
        </div>
        <div v-else-if="action == 'update'" class="p-col-12">
          <div class="p-grid">
            <div class="p-col-12">
              <div class="title is-5">{{ $t("select-divisions") }}</div>
              <p>{{ $t("leave-blank-to-allow-all-divisions") }}</p>
              <div class="p-grid p-mt-1 p-jc-center">
                <div class="p-col-12 p-md-3" v-for="v in $store.getters.currentSeason.divisions" :key="v.id">
                  <Checkbox :value="v.id" v-model="divisions" :name="v.name + '-canPlay'" />
                  <label :for="v.name + '-canPlay'"> {{ v.name }}</label>
                </div>
              </div>
            </div>
            <div class="p-col-6" v-if="false">
              <div class="title is-5">{{ $t("timeslot-usage") }}</div>
              <p>{{ $t("what-can-these-be-used-for") }}</p>
              <div class="p-grid p-mt-1 p-jc-center">
                <div class="p-col-12 p-md-3">
                  <Checkbox v-model="is_game" :binary="true" />
                  <label> {{ $t("item_string.games") }} </label>
                </div>
                <div class="p-col-12 p-md-3">
                  <Checkbox v-model="is_practice" :binary="true" />
                  <label> {{ $t("item_string.practices") }} </label>
                </div>
                <div
                  class="p-col-12 p-md-3"
                  v-tooltip="
                    'Reserved timeslots will not be used in scheduling. They must be un-reserved before being used.'
                  "
                >
                  <Checkbox v-model="is_reserved" :binary="true" />
                  <label> {{ $t("reserved") }} </label>
                </div>
              </div>
            </div>
            <br />
            <div class="p-col-12 p-mt-2">
              <Button class="p-button p-button-lg" :label="$t('update-timeslots')" @click="update" />
            </div>
          </div>
        </div>
        <div v-else-if="action == 'surface'" class="p-col-12">
          <div class="p-grid">
            <div class="p-col-12">
              <div class="title is-5">{{ $t("select-playing-surface") }}</div>
              <div class="p-grid p-mt-1 p-jc-center">
                <div class="p-col-12 p-md-3" v-for="v in $store.getters.currentSeason.venues" :key="v.id">
                  <div>
                    <strong>{{ v.name }} </strong>
                  </div>
                  <div v-for="s in v.surfaces" :key="s.id">
                    <RadioButton :value="s.id" v-model="surface" :name="s.name + '-canPlay'" />
                    <label :for="s.name + '-canPlay'"> {{ s.name }}</label>
                  </div>
                </div>
              </div>
              <br />
              <div class="p-col-12 p-mt-2">
                <Button class="p-button p-button-lg" :label="$t('update-timeslots')" @click="updateSurface" />
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="action == 'split'" class="p-col-12">
          <div class="p-grid">
            <div class="p-col-12">
              <div class="title is-5">{{ $t("split-timeslots") }}</div>
              <div class="p-grid p-mt-1 p-jc-center">
                {{
                  $t(
                    "this-will-split-items-length-timeslots-in-half-resulting-in-items-length-new-additional-timeslots",
                    [items.length, items.length],
                  )
                }}
              </div>
              <br />
              <div class="p-col-12 p-mt-2">
                <Button
                  class="p-button p-button-lg"
                  :label="$t('split-items-length-timeslots', [items.length])"
                  @click="splitTimeslots"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="action == 'delete'" class="p-col-12">
          <Button
            class="p-button p-button-danger p-button-lg"
            :label="$t('delete-timeslots')"
            @click="$emit('delete')"
          />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  props: ["open", "items", "fullitems", "inputaction", "mtype", "sconfig"],
  // ddddd
  data() {
    return {
      is_game: false,
      is_practice: false,
      is_reserved: false,
      copyDate: null,
      copyFrequency: this.$t("weekly"),
      divisions: [],
      surface: null,
      action: "copy",
      value: 1,
      value2: 1,
      moveOptions: {
        numbers: [],
        units: [this.$t("minutes"), this.$t("hours"), this.$t("days"), this.$t("weeks"), this.$t("months")],
      },
      moveChoices: {
        units: this.$t("days"),
        amount: 1,
      },
      frequencies: [this.$t("weekly"), this.$t("monthly")],
    };
  },
  computed: {
    firstDate() {
      var x = null;
      this.fullitems.forEach(i => {
        if (!x || i.start < x) {
          x = i.start;
        }
      });
      return this.$moment(x || new Date()).format("LL");
    },
  },
  methods: {
    hideModal() {
      // console.log("HideModal")
      this.$emit("hide");
    },
    update() {
      console.log("reserved", this.is_reserved);
      // .updateTimeslots(this.currentSeason.id, this.items, this.divisions, this.is_game, this.is_practice, this.is_reserved)
      api
        .updateTimeslots(this.currentSeason.id, this.items, this.divisions)
        .then(response => {
          this.makeToast("success", this.$t("updated-this-items-length-timeslots", [this.items.length]));
          this.$emit("refresh");
        })
        .catch(e => {
          this.makeToast("error", this.$t("could-not-update-timeslot"));
        });
    },
    updateSurface() {
      console.log("updateSurface");
      api
        .updateTimeslotSurface(this.currentSeason.id, this.items, this.surface)
        .then(response => {
          this.makeToast("success", this.$t("updated-this-items-length-timeslots", [this.items.length]));
          this.$emit("refresh");
        })
        .catch(e => {
          this.makeToast("error", this.$t("could-not-update-timeslot"));
        });
    },
    splitTimeslots() {
      console.log("splitTimeslots");
      api
        .splitTimeslots(this.currentSeason.id, this.items)
        .then(response => {
          this.makeToast("success", this.$t("split-this-items-length-timeslots", [this.items.length]));
          this.$emit("refresh");
        })
        .catch(e => {
          this.makeToast("error", this.$t("could-not-split-timeslots"));
        });
    },
    shift() {
      api
        .shiftTimeslots(this.currentSeason.id, this.items, this.moveChoices)
        .then(response => {
          this.makeToast("success", this.$t("shifted-this-items-length-timeslots", [this.items.length]));
          this.$emit("refresh");
        })
        .catch(e => {
          this.makeToast("error", this.$t("Toast.error.something_wrong"));
        });
    },

    copy() {
      api
        .copyTimeslots(this.currentSeason.id, this.items, this.copyDate, this.copyFrequency)
        .then(response => {
          console.log("Response", response);
          if (response.data.skipped == 0) {
            this.makeToast("success", this.$t("created-response-data-count-new-timeslots", [response.data.count]));
          } else {
            this.makeToast(
              "info",
              this.$t("created-response-data-count-new-timeslots-response-data-skipped-skipped-due-to-conflict", [
                response.data.count,
                response.data.skipped,
              ]),
            );
          }
          this.$emit("refresh");
          console.log("Emit last check: " + response.data.last);
          this.$emit("check", response.data.last);
        })
        .catch(e => {
          this.makeToast("error", this.$t("Toast.error.something_wrong"));
        });
    },
    setCopyDate(date) {
      console.log(date);
      this.copyDate = date;
    },
  },
  watch: {
    open: function(val) {
      if (this.inputaction) {
        this.action = this.inputaction;
      }
      if (this.sconfig) {
        this.copyDate = this.sconfig.realEnd;
      }
      this.$forceUpdate();
    },
  },
  created() {},
  mounted() {
    this.moveOptions.numbers = [];
    var i = 1;
    while (i < 21) {
      this.moveOptions.numbers.push(i);
      this.moveOptions.numbers.push(-1 * i);
      i++;
    }
  },
};
</script>

<style scoped lang="scss">
.timeslotActionButton {
  width: 100%;
  display: block;
}
</style>
